<template>
    <div id="Notifications">
        <q-dialog v-model="notificationPopup">
            <NotificationPopup @closeDialog="notificationPopup=false"></NotificationPopup>
        </q-dialog>

        <div v-if="$totalNotificationCount">
            <div  class="row items-start noti-list mb-2 " v-for="(notification,index) in $allNotifications">
                <q-card  :style="{borderLeft:notification.status==='UNREAD'?'3px solid red':'3px solid lightgrey'}"
                        @click="redirectNotification(notification)" bordered
                        class="my-card p-3 w-100" flat>
                    <q-card-section class="row" horizontal style="align-items: center" v-if="notification.notification">
                        <q-card-section class="col-1 p-0">
                            <div class="notification-img">
                                <q-img :src="notification.notification.image?notification.notification.image:getNotificationImage(notification.data.notificationType)"
                                       class="w-100"
                                       style="height: 100%"
                                />
                            </div>
                        </q-card-section>
                        <q-card-section class="col-9 p-0">
                            <div class="text-h5 q-mb-xs">{{notification.notification.title}}</div>
                            <div class="text-body2 text-grey text-overflow">
                                {{notification.notification.body}}
                            </div>
                        </q-card-section>
                        <q-item-section class="col-2 self-baseline">
                            <p class="mb-0 text-caption text-right text-primary">
                                {{timeFromFilter(notification.data.notificationTime)}}
                            </p>
                        </q-item-section>
                    </q-card-section>

                </q-card>
            </div>
        </div>

<!--      <q-item @click="redirectNotification(notification)" clickable :style="{borderLeft:notification.status==='UNREAD'?'3px solid red':'3px solid lightgrey'}" v-if="$totalNotificationCount" v-for="(notification,index) in $allNotifications" :key="index">-->
<!--        <q-item-section top avatar>-->
<!--&lt;!&ndash;          <q-avatar rounded>&ndash;&gt;-->

<!--            <q-img :src="notification.notification.image?notification.notification.image:getNotificationImage(notification.data.notificationType)" />-->
<!--&lt;!&ndash;          </q-avatar>&ndash;&gt;-->
<!--        </q-item-section>-->

<!--        <q-item-section>-->
<!--          <q-item-label>{{notification.notification.title}}</q-item-label>-->
<!--          <q-item-label caption>{{notification.notification.body}}</q-item-label>-->
<!--        </q-item-section>-->

<!--        <q-item-section side top>-->
<!--          <q-item-label caption>{{timeFromFilter(notification.data.notificationTime)}}</q-item-label>-->
<!--        </q-item-section>-->
<!--      </q-item>-->


        <div v-else>
            <img src="./../../assets/notification.svg" style="width: 20%; opacity: 0.8" class="mt-5 mx-auto d-block"
                 alt="no_data">
            <h6 class="text-center text-blue-grey-8 mt-3">No Notifications Available</h6>
        </div>
        <div class="text-center cursor-pointer"
             v-if="$allNotifications.length<$totalNotificationCount">
            <a @click="loadMoreNotification" style="color: #014da3">View More</a>
        </div>
    </div>
</template>

<script>
    import {loadMoreNotification, onNotificationClick, refreshNotification} from './NotificationUtils'
    import Constants from '../../Constants/Constant'
    import NotificationPopup from './NotificationPopup'

    export default {
        name: 'Notifications',
        data() {
            return {
                defaultNotificationImage: require('../../assets/icons/notification.png'),
                defaultOrderImage: require('../../assets/icons/order.png'),
                defaultSchemeImage: require('../../assets/icons/scheme.png'),
                notificationPopup: false,
            }
        },
        components: {NotificationPopup},
        mounted() {
            let self = this
            setInterval(function () {
                refreshNotification()
                self.$forceUpdate()
            }, Constants.notificationTimeout)
        },
        methods: {
            getNotificationImage(notificationType) {
                if (notificationType == 11 || notificationType == 55)
                    return this.defaultOrderImage
                else if (notificationType == 22)
                    return this.defaultSchemeImage
                else
                    return this.defaultNotificationImage
            },
            redirectNotification(notification) {
                if (notification && notification.data && notification.data.notificationType) {
                    onNotificationClick(notification)
                    if (notification.data.notificationType == '33' || notification.data.notificationType == '44')
                        this.notificationPopup = true
                }
            },
            loadMoreNotification() {
                this.$nextTick().then(() => {
                    loadMoreNotification()
                    this.$forceUpdate()
                })
            },
        },
    }
</script>

<style scoped>
    .notification-img {
        height: 50px;
        width: 50px;
        border-radius: 80px;
        /*background-color: lightgrey;*/
        overflow: hidden;
    }

    .my-card {
        transition: all 0.3s;
        /*height: 100px;*/
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .my-card:hover {
        cursor: pointer;
        background: #f0f0f0;
    }

    .noti-list {
        padding-left: 150px;
        padding-right: 150px;
    }


    .text-overflow {
        text-overflow: ellipsis;
        overflow: hidden;
        display: block;
        /* white-space: nowrap; */
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        /* line-height: 1; */
    }


</style>
